<template>
  <w-icon-wrapper
    :height='23.216'
    :width='37.864'
    icon-name='work-collapse-icon'
    view-box='0 0 24 23.216'
  >
    <g
      id="_81_Einklappen_Icon"
      data-name="81 Einklappen_Icon"
      transform="translate(-670.23 -475.775)"
    >
      <path
        id="Pfad_55823"
        data-name="Pfad 55823"
        d="M688.77,492.135v2.39h-8.66a7.886,7.886,0,0,0,2.92-2.39Z"
        transform="translate(0.071 0.084)"
        fill="currentColor"
      />
      <path
        id="Pfad_55824"
        data-name="Pfad 55824"
        d="M688.77,487.335v2.39h-4.5a7.863,7.863,0,0,0,.37-2.39Z"
        transform="translate(0.08 0.059)"
        fill="currentColor"
      />
      <path
        id="Pfad_55822"
        data-name="Pfad 55822"
        d="M687.269,475.775h-9.275a2.321,2.321,0,0,0-2.314,2.321v1.326a7.83,7.83,0,0,1,.976-.06,8.518,8.518,0,0,1,1.348.11V478.1h8.118v5.8h5.794l-.01,12.779H678v-1.376a8.511,8.511,0,0,1-1.348.111,7.83,7.83,0,0,1-.976-.06v1.326a2.306,2.306,0,0,0,2.3,2.321h13.923a2.317,2.317,0,0,0,2.324-2.321V482.737Z"
        transform="translate(0 0)"
        fill="currentColor"
      />
      <path
        id="Pfad_55825"
        data-name="Pfad 55825"
        d="M670.23,487.388a6.438,6.438,0,0,0,2.17,4.84,5.085,5.085,0,0,0,.97.706,6.016,6.016,0,0,0,1.95.786,6.5,6.5,0,0,0,1.34.141,6.19,6.19,0,0,0,.97-.081,6.474,6.474,0,0,0,0-12.785,6.193,6.193,0,0,0-.97-.081,6.43,6.43,0,0,0-6.43,6.473Zm6.55,3.136,3.1-3.136-3.1-3.146.66-.676,3.77,3.821-3.77,3.811Zm-.31-3.136-3.1-3.146.67-.676,3.77,3.821-3.77,3.811-.67-.676Z"
        transform="translate(0 0)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCollapse' };
</script>
